import React, { useState } from 'react'

import { Button, Col, Form, Input, Row, Typography } from 'antd'

import CustomMap from '../CustomMap/customMap'
const { Text } = Typography

export default function GpsMaping(props) {
  const { field, value, name, errors, setFieldValue, required, disabled } = props
  const [mapLatitude, setMapLatitude] = useState(undefined)
  const [address, setAddress] = useState(undefined)
  const [mapLongitude, setMapLongitude] = useState(undefined)
  const [, setMapZoom] = useState(undefined)

  const getValidCoordinate = (num) => (isNaN(num) ? 0 : num)

  const onLatLongChange = (valueData) => {
    //so apago o endereco caso lat e long sejam diferentes da que tenho
    if (valueData.mapLatitude !== mapLatitude || valueData.mapLongitude !== mapLongitude) {
      setAddress('')
    }
  }

  const showMessageError = () => {
    const errorsOnFields = Object.keys(errors)
    if (errorsOnFields.length > 0 && errorsOnFields.includes(name)) {
      const msgError = errors[name]
      return (
        <Col span={24} style={{ marginTop: 5, marginBottom: 10 }}>
          <Text type="danger">{msgError}</Text>
        </Col>
      )
    } else {
      return null
    }
  }

  const requiredField = (marginLeft) => {
    if (required) {
      return (
        <Text
          className="required-asterisk"
          style={{ position: 'absolute', top: 8, marginLeft: marginLeft, color: 'red' }}
        >
          *
        </Text>
      )
    } else {
      return null
    }
  }

  React.useEffect(() => {
    if (value && value[name]) {
      const val = JSON.parse(value[name])
      setAddress(val.address)
      setMapLatitude(val.lat)
      setMapLongitude(val.long)
    }
  }, [value])

  return (
    <Row type="flex">
      <Col span={6}>
        <Text className="ant-col ant-form-item-label">Latitude</Text>
        {requiredField(45)}
        <Form.Item validateStatus={errors[field] ? 'error' : 'validating'} help={errors[field]}>
          <Input
            id={props.id}
            disabled={disabled}
            value={mapLatitude}
            onChange={(e) => {
              setMapLatitude(e.target.value.replace(/[a-zA-Z]+/g, ''))
            }}
          />
        </Form.Item>
      </Col>
      <Col span={6}>
        <Text className="ant-col ant-form-item-label">Longitude</Text>
        {requiredField(55)}
        <Form.Item validateStatus={errors[field] ? 'error' : 'validating'} help={errors[field]}>
          <Input
            value={mapLongitude}
            disabled={disabled}
            onChange={(e) => {
              setMapLongitude(e.target.value.replace(/[a-zA-Z]+/g, ''))
            }}
          />
        </Form.Item>
      </Col>
      <Col span={8}>
        <Form.Item label="Endereço" validateStatus={errors[field] ? 'error' : 'validating'} help={errors[field]}>
          <Input
            value={address}
            disabled={disabled}
            onChange={(e) => {
              setAddress(e.target.value)
            }}
          />
        </Form.Item>
      </Col>
      <Col span={4}>
        <Button
          disabled={disabled}
          onClick={() => {
            if (mapLatitude && mapLongitude) {
              setFieldValue(
                name,
                JSON.stringify({
                  lat: getValidCoordinate(mapLatitude),
                  long: getValidCoordinate(mapLongitude),
                  address: address
                })
              )
            }
          }}
          style={{ marginTop: 22, float: 'right', width: '80%' }}
        >
          Salvar
        </Button>
      </Col>
      <Col span={24}>
        <Row type="flex" justify="start">
          <CustomMap
            disabled={disabled}
            latitude={getValidCoordinate(mapLatitude)}
            longitude={getValidCoordinate(mapLongitude)}
            zoom={8}
            setMapLatitude={setMapLatitude}
            setMapLongitude={setMapLongitude}
            setMapZoom={setMapZoom}
            callbackData={onLatLongChange}
          />
        </Row>
      </Col>
      {showMessageError()}
    </Row>
  )
}
